export default __webpack_public_path__ + "static/media/nft-bg.d2ed10b2.jpg";